/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FileDtoFromJSON, FileDtoToJSON, } from './';
export function DamageDetailDtoFromJSON(json) {
    return DamageDetailDtoFromJSONTyped(json, false);
}
export function DamageDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'documentationPhotos': !exists(json, 'documentationPhotos') ? undefined : (json['documentationPhotos'] === null ? null : json['documentationPhotos'].map(FileDtoFromJSON)),
        'damageDictionaryId': !exists(json, 'damageDictionaryId') ? undefined : json['damageDictionaryId'],
        'kindsIds': !exists(json, 'kindsIds') ? undefined : json['kindsIds'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}
export function DamageDetailDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'documentationPhotos': value.documentationPhotos === undefined ? undefined : (value.documentationPhotos === null ? null : value.documentationPhotos.map(FileDtoToJSON)),
        'damageDictionaryId': value.damageDictionaryId,
        'kindsIds': value.kindsIds,
        'note': value.note,
    };
}
